module.exports = __webpack_public_path__ + "e1d9d74a17429a3c61ca057a602e3c2d.png";